export const introtext0 = 
`
### _There are 2 types of people in this world; those who rely on autodiff everyday, and those who don't realise it._
`.trim();


export const introtext1 = 
`
Automatic differentiation, or autodiff, is a technique that is almost like black magic when you first learn 
about it; it can let you accurately calculate the derivative of a function without the pitfalls of other 
methods like numerical or symbolic. This method has been a staple of basically any ML problem for forever now. 
For something so ubiquitous, it is not something most people have to care about, since the library they 
use automagically handles it all for them. I think it is still worth understanding how it works, 
most importantly to know _when it doesn't_.
`.trim();



export const introtext2 = 
`

In this post, we'll be diving deep into the inner workings of this algorithm that powers libraries you know and love 
like __tensorflow__, __pytorch__ and __JAX__.

_P.S. This explainer is meant to be a more in-depth explanation of the code in the [picograd](https://github.com/StealthyPanda/picograd) engine I made._
`.trim();